/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React, { useState, useEffect } from 'react';
import { IMoeKwrResourceinfoViewProps } from './moe-kwr-resourceinfo';
import { resourceInfoStyle, typeOfResource } from './moe-kwr-resourceinfo.props.autogenerated';
import { getToggleLang } from '../../utilities/language-change';

const MOBILE_BREAKPOINT = 768;

export default (props: IMoeKwrResourceinfoViewProps) => {
    const { data, config, context, resources } = props;

    const imageSource = config.resourceImage?.src ? config.resourceImage?.src : data.product.result?.PrimaryImageUrl;
    const imageName = config?.resourceImage?.title || data.product.result?.Name;
    const resourceTitle = config.resourceTitle || data.product.result?.Name;

    const toggleLanguage = getToggleLang(context);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
    const [isModalOpen, setIsModalOpen] = useState(!isMobile);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    useEffect(() => {
        const handleResize = () => {
            const isMobileView = window.innerWidth <= MOBILE_BREAKPOINT;

            setIsMobile(prevIsMobile => {
                if (prevIsMobile !== isMobileView) {
                    setIsModalOpen(!isMobileView); // Open on desktop, close on mobile
                }

                return isMobileView;
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // const _modalContainer = (): INodeProps => {
    //     return {
    //         tag: Modal,
    //         placement: 'bottom-end',
    //         hideArrow: true,
    //         className: 'moe-resourceinfo__modal',
    //         wrapClassName: 'moe-resourceinfo__modal-container',
    //         isOpen: isModalOpen,
    //         toggle: toggleModal
    //     };
    // };

    return (
        <div tabIndex={0} className='moe-side-nav-wrap'>
            <div className='moe-side-nav-menu'>
                <div onClick={toggleModal} className='moe-side-nav-menu__btn'>
                    <span className='moe-side-nav-menu__icon'></span>
                </div>
            </div>
            <div className={`moe-side-nav ${isModalOpen ? 'show' : 'fade'}`}>
                <div className='moe-side-nav__list'>
                    {config.resourceInfoStyle === resourceInfoStyle.vertical && (
                        <div className='moe-side-nav__item vertical'>
                            {imageSource && (
                                <div className='moe-thumbnail'>
                                    <img
                                        src={imageSource}
                                        alt={imageName || 'resource'}
                                        aria-label={imageName || 'resource'}
                                        className='lazyloaded'
                                    />
                                </div>
                            )}
                            <div className='moe-side-nav__item-cont'>
                                <h4 className='moe-side-nav__item-ttl'>{resourceTitle}</h4>
                                <div className='moe-side-nav__item-des'>
                                    {config.typeOfResource === typeOfResource.video && (
                                        <>
                                            <i className='moe-icon-video'></i>
                                            <span>
                                                {toggleLanguage === 'maori' ? resources.videoIconNameInMaori : resources.videoIconName}
                                            </span>
                                        </>
                                    )}
                                    {config.typeOfResource === typeOfResource.audio && null}
                                    {config.typeOfResource === typeOfResource.mobileApp && (
                                        <>
                                            <i className='moe-icon-mobileapp'></i>
                                            <span>
                                                {toggleLanguage === 'maori'
                                                    ? resources.mobileAppIconNameInMaori
                                                    : resources.mobileAppIconName}
                                            </span>
                                        </>
                                    )}
                                    {config.typeOfResource === typeOfResource.digitalInteractive && (
                                        <>
                                            <i className='moe-icon-dg-interactive'></i>
                                            <span>
                                                {toggleLanguage === 'maori'
                                                    ? resources.digitalInteractiveIconNameInMaori
                                                    : resources.digitalInteractiveIconName}
                                            </span>
                                        </>
                                    )}
                                    {config.typeOfResource === typeOfResource.web && (
                                        <>
                                            <i className='moe-icon-web'></i>
                                            <span>{toggleLanguage === 'maori' ? resources.webIconNameInMaori : resources.webIconName}</span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    {config.resourceInfoStyle === resourceInfoStyle.horizontal && (
                        <div className='moe-side-nav__item horizontal'>
                            {imageSource && (
                                <div className='moe-thumbnail'>
                                    <img
                                        src={imageSource}
                                        alt={imageName || 'resoource'}
                                        aria-label={imageName || 'resource'}
                                        className='lazyloaded'
                                    />
                                </div>
                            )}
                            <div className='moe-side-nav__item-cont'>
                                <h4 className='moe-side-nav__item-ttl'>{imageName}</h4>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
